module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/205/assets/images/68d43675a08746362caacb721419fe43.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_person.svg
// module id = 5/30
// module chunks = 1